module.exports = __webpack_public_path__ + "static/img/customer9.9e68b84f.png";